// 관리자 테이블 컬럼 헤더 컴포넌트 (db 툴팁 기능 제거됨)
import React from 'react';

export default function AdminColHeader({ label }) {
  return <>{label}</>;
}
